import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useIndexQuery } from "../api/genericHooks";
import { AudioPlaylistCard } from "../components/AudioPlaylistCard";
import { AudioProvider } from "../contexts/AudioContext";

// Public page of a shared audio book (no account needed). The playlist needs
// the audio context, which the signed-in layout provides elsewhere.
export const AudioBookPublic: FC = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const audio_book_token = new URLSearchParams(search).get("token");
  const audioBook = useIndexQuery(
    "/audio_book",
    audio_book_token
      ? {
          audio_book_token: audio_book_token,
        }
      : undefined,
    { enabled: !!audio_book_token, retry: false },
  );
  if (audioBook.isLoading && audio_book_token) {
    return <div>Loading...</div>;
  }
  const chapters = audioBook.data?.audio_book ?? [];
  return (
    <AudioProvider>
      <div className="w-full px-4 sm:px-6 lg:px-12 py-4 sm:py-6 lg:py-8 flex flex-1 flex-col gap-y-4 sm:gap-y-6">
        {chapters.length > 0 ? (
          <AudioPlaylistCard playlist={chapters} />
        ) : (
          <p className="text-center text-slate-500">
            {t("audioBookPublic.not_found")}
          </p>
        )}
      </div>
    </AudioProvider>
  );
};
